import React, { Component } from "react";
import "./ContactSection2.css";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";

export default class ContactSection2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captcha: null,
    };
  }

  sendEmail = (e) => {
    e.preventDefault();

    if (!this.state.captcha) {
      alert("יש לאמת שאתה לא רובוט 🤖");
      return;
    }

    emailjs
      .sendForm(
        "service_z61yzfo",
        "template_f41rbnw",
        e.target,
        "iT7YbqtR1ZmPR7EOD"
      )
      .then(
        () => {
          alert("הודעה נשלחה בהצלחה 👍, ניצור קשר בקרוב ");

          e.target.reset();

          this.setState({
            captcha: null,
          });
        },
        (error) => {
          console.log("EmailJS Error:", error);
          alert("הודעה לא נשלחה, נסה שנית");
        }
      );
  };

  handleCaptchaChange = (value) => {
    this.setState({
      captcha: value,
    });
  };

  render() {
    return (
      <div className="form-box">

        <h3>
          לקבלת ייעוץ ראשוני, מלא פרטים ונשוב אליכם בהקדם
        </h3>

        <form
          onSubmit={this.sendEmail}
          className="form"
        >

          <input
            type="text"
            name="name"
            placeholder="שם מלא"
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="טלפון"
            required
          />

          <button type="submit">
            שליחה
          </button>

        </form>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "15px",
          }}
        >
          <ReCAPTCHA
            sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
            onChange={this.handleCaptchaChange}
          />
        </div>

      </div>
    );
  }
}
